// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IIrsLimitDto } from './IIrsLimitDto';
import {
    IIrsLimitDtoFromJSON,
    IIrsLimitDtoFromJSONTyped,
    IIrsLimitDtoToJSON,
    IIrsLimitDtoToJSONTyped,
} from './IIrsLimitDto';
import type { ITotalEmployeeContributionDto } from './ITotalEmployeeContributionDto';
import {
    ITotalEmployeeContributionDtoFromJSON,
    ITotalEmployeeContributionDtoFromJSONTyped,
    ITotalEmployeeContributionDtoToJSON,
    ITotalEmployeeContributionDtoToJSONTyped,
} from './ITotalEmployeeContributionDto';

/**
 * 
 * @export
 * @interface IMonitorContributionAggregateResponseDto
 */
export interface IMonitorContributionAggregateResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof IMonitorContributionAggregateResponseDto
     */
    is_with_catch_up_age?: boolean;
    /**
     * 
     * @type {ITotalEmployeeContributionDto}
     * @memberof IMonitorContributionAggregateResponseDto
     */
    total_employee_contribution?: ITotalEmployeeContributionDto;
    /**
     * 
     * @type {Array<IIrsLimitDto>}
     * @memberof IMonitorContributionAggregateResponseDto
     */
    irs_limits?: Array<IIrsLimitDto>;
}

/**
 * Check if a given object implements the IMonitorContributionAggregateResponseDto interface.
 */
export function instanceOfIMonitorContributionAggregateResponseDto(value: object): value is IMonitorContributionAggregateResponseDto {
    return true;
}

export function IMonitorContributionAggregateResponseDtoFromJSON(json: any): IMonitorContributionAggregateResponseDto {
    return IMonitorContributionAggregateResponseDtoFromJSONTyped(json, false);
}

export function IMonitorContributionAggregateResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IMonitorContributionAggregateResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'is_with_catch_up_age': json['is_with_catch_up_age'] == null ? undefined : json['is_with_catch_up_age'],
        'total_employee_contribution': json['total_employee_contribution'] == null ? undefined : ITotalEmployeeContributionDtoFromJSON(json['total_employee_contribution']),
        'irs_limits': json['irs_limits'] == null ? undefined : ((json['irs_limits'] as Array<any>).map(IIrsLimitDtoFromJSON)),
    };
}

export function IMonitorContributionAggregateResponseDtoToJSON(json: any): IMonitorContributionAggregateResponseDto {
    return IMonitorContributionAggregateResponseDtoToJSONTyped(json, false);
}

export function IMonitorContributionAggregateResponseDtoToJSONTyped(value?: IMonitorContributionAggregateResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_with_catch_up_age': value['is_with_catch_up_age'],
        'total_employee_contribution': ITotalEmployeeContributionDtoToJSON(value['total_employee_contribution']),
        'irs_limits': value['irs_limits'] == null ? undefined : ((value['irs_limits'] as Array<any>).map(IIrsLimitDtoToJSON)),
    };
}

